import { z } from 'zod';
/** Canonical storage units. Everything else is converted at the edge. */
export const canonicalUnitSchema = z.enum(['g', 'ml']);
/** Units a user may enter against a food or ingredient line. */
/** `item` is a count of a per-item food, or of one with a typical weight (ADR-028). */
export const quantityUnitSchema = z.enum(['g', 'ml', 'measure', 'item']);
/** Units an inventory item may be held in (servings for leftovers). */
export const inventoryUnitSchema = z.enum(['g', 'ml', 'serving', 'item']);
/**
 * A boolean read from a query string. `z.coerce.boolean()` is wrong here: it
 * applies JavaScript truthiness, so the string "false" becomes true.
 */
export const booleanParam = (fallback) => z
    .union([z.boolean(), z.string()])
    .default(fallback)
    .transform((value) => typeof value === 'boolean' ? value : !['false', '0', 'no', 'off', ''].includes(value.toLowerCase()));
/** What a food's nutrient figures are per: 100 g or 100 ml, or one item (ADR-028). */
export const nutritionPerSchema = z.enum(['weight', 'item']);
//# sourceMappingURL=units.js.map